import styled from "@emotion/styled";
import { BaseInput, baseInputClasses, IconButton } from "@kaltura/ds-react-components";
import { svgIconClasses } from "@mui/material/SvgIcon";

export const StyledIconRow = styled("div")(({ theme }) => ({
    margin: theme.spacing(2, 0, 5, 0),
    textAlign: "center",
}));

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
    height: theme.spacing(6),
    width: theme.spacing(6),
    borderRadius: "50%",
    marginRight: theme.spacing(2),
    ":last-child": {
        marginRight: 0,
    },
    [`.${svgIconClasses.root}`]: {
        height: 32,
        width: 32,
    },
})) as unknown as typeof IconButton;

export const StyledInputRow = styled("div")({
    display: "flex",
});

export const StyledInput = styled(BaseInput)(({ theme }) => ({
    flexGrow: 2,
    marginRight: theme.spacing(2),
    [`&.${baseInputClasses.readOnly}`]: {
        borderColor: theme.kaltura.palette.tone4,
    },
}));

export const StyledConfigRow = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    marginTop: theme.spacing(2),
}));
